module.exports = __webpack_public_path__ + "static/media/R8.e601d5fc.jpg";